import React, {useState,useContext,useEffect} from 'react';
import {Link} from 'react-router-dom';
import alertaContext from '../../context/alertas/alertaContext';
import authContext from '../../context/autenticacion/authContext';

const NuevaCuenta = (props) => {//props por react router dom, para luego acceder a props.history
    //extraer los valores del context
    const AlertaContext=useContext(alertaContext);
    const {alerta,mostrarAlerta}=AlertaContext;

    const AuthContext= useContext(authContext);
    const {registrarUsuario, mensaje,autenticado}=AuthContext;

    //en caso de que el usuario se haya registrado, autenticado o sea un registro duplicado
    useEffect(() => { 
        if(autenticado){
            props.history.push('/proyectos') //si esta autenticado lo manda a /proyectos... 
        }
    
        if(mensaje){
            mostrarAlerta(mensaje.msg, mensaje.categoria);
                
        }
        // eslint-disable-next-line
    }, [mensaje, autenticado, props.history]);

    
    
    //state para iniciar sesion
    const [usuario, guardarUsuario] = useState({
        nombre:'',
        email:'',
        password:'',
        confirmar:''
    });
    // extraer usuario
    const {nombre, email, password, confirmar} = usuario;

    const handleChange = e =>{
        guardarUsuario({
          ...usuario,
          [e.target.name]: e.target.value
        })

    }

    //cuando el usuario quiere iniciar sesion
    const handleSubmit=e=>{
        e.preventDefault();

        //validar que no haya campos vacios
            if(nombre.trim()==='' ||email.trim()==='' ||password.trim()==='' ||confirmar.trim()==='' ){

                mostrarAlerta('Todos los campos son obligatorios', 'alerta-error')
                return;
            }
        //password minimo de 6 caracteres

        if(password.length<6){
            mostrarAlerta('El password debe ser de almenos 6 caracteres', 'alerta-error')
            return;
        }
        //que los dos password sean iguales
        if(password!==confirmar){
            mostrarAlerta('Los password no coinciden', 'alerta-error')
            return;
        }

        //pasar al action
        registrarUsuario({
            nombre,
            email,
            password
        });
    }

    return ( 
        <div className="form-usuario">
            {alerta ? <div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div>  : null}
            <div className="contenedor-form sombra-dark">
                <h1>Crear Cuenta</h1>
                <form
                    onSubmit={handleSubmit}
                >
                     <div className="campo-form">
                        <label htmlFor="email">Nombre</label>
                        <input
                            type="text"
                            id="nombre"
                            name="nombre"
                            placeholder="Tu nombre"
                            onChange={handleChange}
                            value={nombre}
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Tu email"
                            onChange={handleChange}
                            value={email}
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="password">password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Tu password"
                            onChange={handleChange}
                            value={password}
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="confirmar">Confirmar Password</label>
                        <input
                            type="password"
                            id="confirmar"
                            name="confirmar"
                            placeholder="Repite tu password"
                            onChange={handleChange}
                            value={confirmar}
                        />
                    </div>
                    <div className="campo-form">
                        <input
                            type="submit"
                            className="btn btn-block btn-primario"
                            value="Registrarme"
                        />
                    </div>
                </form>
                <Link to={'/'} className="enlace-cuenta">
                    Volver a Iniciar Sesión
                </Link>
            </div>
        </div>
     );
}
 
export default NuevaCuenta;